class o extends HTMLElement{constructor(){super(),this.form=this.querySelector("form"),this.form.querySelector("[name=id]").disabled=!1,this.form.addEventListener("submit",r=>this.onSubmitHandler(r));const e=document.querySelectorAll("cart-notification");this.cartNotification=e[e.length-1],this.submitButton=this.querySelector('[type="submit"]'),this.submitButtonText=this.submitButton.querySelector("span"),this.hideErrors=this.dataset.hideErrors==="true"}onSubmitHandler(e){e.preventDefault();const r="loading";if(this.submitButton.classList.contains(r))return;this.handleErrorMessage(),this.cartNotification.setActiveElement(document.activeElement),this.submitButton.setAttribute("aria-disabled",!0),this.submitButton.classList.add(r);const s=theme.fetchConfig("javascript");s.headers["X-Requested-With"]="XMLHttpRequest",delete s.headers["Content-Type"];const i=new FormData(this.form);i.append("sections",this.cartNotification.getSectionsToRender().map(t=>t.id)),i.append("sections_url",window.location.pathname),s.body=i,fetch(`${theme.routes.cart_add_url}`,s).then(t=>t.json()).then(t=>{if(t.status){publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:i.get("id"),errors:t.errors||t.description,message:t.message}),this.handleErrorMessage(t.description);return}this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:i.get("id"),cartData:t}),this.error=!1,this.cartNotification.renderContents(t)}).catch(t=>{console.error(t)}).finally(()=>{this.submitButton.classList.remove(r),this.submitButton.removeAttribute("aria-disabled")})}handleErrorMessage(e=!1){this.hideErrors||(this.errorMessageContainer=this.errorMessageContainer||this.querySelector(".product-form__error-container"),this.errorMessage=this.errorMessage||this.errorMessageContainer.querySelector(".product-form__error-message"),this.errorMessageContainer.toggleAttribute("hidden",!e),e&&(this.errorMessage.textContent=e))}}customElements.define("product-form",o);
document.addEventListener('DOMContentLoaded', function () {
  // Hook the semantic data-buy-now attribute instead of matching the English
  // button label, so this survives locale changes.
  const buyNowForm = document.querySelector('form[data-buy-now="true"]');
  const buyNowButton = buyNowForm ? buyNowForm.querySelector('button[type="submit"]') : null;

  const buttonTextEl = buyNowButton ? buyNowButton.querySelector('.button-text') : null;
  const spinnerEl = buyNowButton ? buyNowButton.querySelector('.loading-spinner') : null;

  if (buyNowForm && buyNowButton && buttonTextEl && spinnerEl) {
    buyNowForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Sync the shopper's chosen variant. This form's hidden id input is
      // rendered once at page load, but variant-selects.js only keeps the main
      // product form (#product-form-*) and #product-form-installment in sync.
      // Without this, Buy Now would add the page-load default variant even
      // after the shopper picks another one.
      const productFormEl = buyNowForm.closest('product-form');
      const liveVariantInput = productFormEl
        ? productFormEl.querySelector('form:not([data-buy-now]) input[name="id"]')
        : null;
      const buyNowVariantInput = buyNowForm.querySelector('input[name="id"]');
      if (liveVariantInput && buyNowVariantInput) {
        buyNowVariantInput.value = liveVariantInput.value;
      }

      buyNowButton.disabled = true;
      buttonTextEl.style.display = 'none';
      spinnerEl.classList.add('visible');

      const formData = new FormData(buyNowForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || 'Unable to add this item.');
        }
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Buy Now error:', error);
        buyNowButton.disabled = false;
        buttonTextEl.style.display = 'inline';
        spinnerEl.classList.remove('visible');
        // Surface the failure in the product form's error container instead of
        // silently landing on checkout with nothing added.
        const errBox = productFormEl ? productFormEl.querySelector('.product-form__error-container') : null;
        const errMsg = errBox ? errBox.querySelector('.product-form__error-message') : null;
        if (errBox && errMsg) {
          errMsg.textContent = error && error.message ? error.message : 'Unable to add this item.';
          errBox.removeAttribute('hidden');
        }
      });
    });
  }
});
